// extracted by mini-css-extract-plugin
export default {"customReporting":"customReporting_customReporting__jE8TP","card":"customReporting_card__gi6QD"};